import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useSelector, useDispatch } from "react-redux"
import BreadcrumbWrapper from "../BreadcrumbWrapper/BreadcrumbWrapper"
import ImageWithText from "../ImageWithText/ImageWithText"
import JobFilter from "../JobFilter/JobFilter"
import { labels } from "../../constants/label.constants"
import { getUrlValues, updatePageUrl } from "../../helpers/search"
import Link from "../../components/UI/Link/Link"
import { getAllJobs } from "../../redux/actions/jobListActions"
import CustomPagination from "../Pagination/CustomPagination"
import * as styles from "./JobListing-tw-styles"
import LoaderIcon from "../../assests/icons/LoaderIcon"
import ModalWrapper from "../Wrappers/ModalWrapper/ModalWrapper"
import SearchJobs from "./SearchJobs"
import { gaEventClick } from "../../constants/gtm.constants"
import ContentfulComponents from "../../helpers/ContentfulComponents"
import { getSourceDomain, getUTMParams } from "../../helpers/utils"
const { getAllCountriesResults } = require("../../service/JobsService")

const orderList = (list, actualList) => {
  actualList?.selectFields &&
    Object.entries(list).map(([key]) => {
      list[key] = actualList?.selectFields[key]
      return list[key]
    })
  actualList.selectFields = list
}

let orderedFieldList = {
  countrycode: "",
  stateprovincecode: "",
  locationid: "",
  jobFamily: "",
  timeType: "",
  jobType: "",
}

const nonFilters = ["countrycode", "page", "term"]

const JobListing = props => {
  const { componentProps, dataLayer } = props || {}
  const [countriesListApi, setcountriesListApi] = useState([])
  const [utmParams, setUtmParams] = useState("")
  const breadCrumbDets =
    (componentProps && componentProps[0]?.BreadcrumbWrapper) || {}
  const filterData =
    (componentProps && componentProps[1]?.JobFilter?.filterData) || {}
  // const imageWithText =
  // (componentProps && componentProps[2]?.ImageWithText) || {}
  let appliedFilters = getUrlValues()
  if (appliedFilters?.prevFilters?.length > 0) {
    appliedFilters.prevFilters = appliedFilters?.prevFilters?.map(obj => {
      let newObj = {}
      for (let key in obj) {
        if (key === "term") {
          return obj
        } else if (labels?.filterKeys[key?.toLowerCase()]) {
          newObj[labels?.filterKeys[key?.toLowerCase()]] =
            key?.toLowerCase() === "timetype" ||
            key?.toLowerCase() === "jobtype"
              ? obj[key].charAt(0).toUpperCase() +
                obj[key].slice(1).toLowerCase()
              : obj[key].toUpperCase()
        } else {
          newObj[key] = obj[key].toUpperCase()
        }
      }
      return newObj
    })
  }

  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1)
  const [selectedStateName, setSelectedStateName] = useState("")
  const [selectedCountryName, setSelectedCountryName] = useState("")
  const [selectedStateCode, setSelectedStateCode] = useState("")
  const [selectedCountryCode, setSelectedCountryCode] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [isInitialRender, setIsInitialRender] = useState(true)
  orderList(orderedFieldList, filterData)
  const [data, setData] = useState(filterData)
  const [isLoading, setIsLoading] = useState(true)
  const [filterValidation, setFilterValidation] = useState(false)
  const { jobListReducer } = useSelector(state => state)
  const { jobRes } = jobListReducer
  const { hits = [], nbHits } = jobRes
  let countrySelected = false
  let countryOptions = []

  useEffect(() => {
    (async () => {
      let countriesList = await getAllCountriesResults()
      setcountriesListApi(countriesList)
    })();
  }, [])

  useEffect(() => {
    countryOptions?.push(labels?.countrySelectObj)
    Object?.entries(countriesListApi)?.map(itm =>
      countryOptions.push({
        label: itm[1]?.countryName,
        value: itm[1]?.countryCode,
      })
    )
    filterData.selectFields.countrycode.options = countryOptions
    let pageNumber
    let algoliaPage
    let term
    let selectedFilters = {
      selectedLocations: "",
      jobType: "",
      jobFamily: "",
      timeType: "",
      earlyCareers: "",
    }
    let selectedLocs = []
    // fn to fetch the values from query params in the url & get the previosly applied filters value
    appliedFilters?.prevFilters?.length &&
      appliedFilters?.prevFilters?.map(
        itm =>
          appliedFilters?.prevFilters &&
          Object?.entries(itm)?.map(key => {
            if (key[0] == labels?.term) {
              term = key[1]
              setSearchTerm(key[1])
            }
            if (key[0] == labels?.countrycode) {
              countrySelected = true
              key[0] &&
                Object?.entries(countriesListApi)?.map(itm => {
                  if (itm[1]?.countryCode == key[1]) {
                    itm[1]?.locations?.map(state => {
                      if (state.value !== "") {
                        selectedLocs.push(state.value)
                      }
                    })
                    if (itm[1]?.locations?.length == 0) {
                      selectedLocs?.push(key[1])
                    }
                    let stateOptions = []
                    stateOptions.push(labels?.stateSelectObj)
                    itm[1]?.stateWithLocations?.map(e => {
                      stateOptions.push({
                        label: e?.stateName,
                        value: e?.stateCode,
                      })
                    })
                    filterData.selectFields.stateprovincecode.options =
                      stateOptions
                    filterData.selectFields.locationid.options =
                      itm[1].locations
                  }
                  return ""
                })
              selectedFilters.selectedLocations = selectedLocs
            }
            if (key[0] == labels?.stateprovincecode) {
              const selecedLocations = []
              key[0] &&
                Object?.entries(countriesListApi)?.map(itm => {
                  itm[1]?.stateWithLocations?.map(ele => {
                    if (ele.stateCode == key[1]) {
                      const currentState = [
                        labels.stateSelectObj,
                        {
                          label: ele?.stateName,
                          value: ele?.stateCode,
                        },
                      ]
                      ele?.locations?.map(i => selecedLocations.push(i.value))
                      filterData.selectFields.stateprovincecode.options =
                        currentState
                      filterData.selectFields.locationid.options =
                        ele?.locations
                      filterData.selectFields.stateprovincecode.value =
                        ele?.stateCode
                      //filterData.selectFields.locationid.value = e?.value
                    }
                  })
                  return ""
                })
              selectedFilters.selectedLocations =
                key[1] !== "" ? selecedLocations : ""
            }
            if (key[0] == labels?.locationid) {
              const locs = []
              key[0] &&
                Object?.entries(countriesListApi)?.map(itm => {
                  let hasMatch = false
                  itm[1]?.stateWithLocations?.map(ele => {
                    ele?.locations?.map(e => {
                      if (e.value == key[1]) {
                        hasMatch = true
                        const currentState = [
                          labels?.stateSelectObj,
                          {
                            label: ele?.stateName,
                            value: ele?.stateCode,
                          },
                        ]
                        locs.push(e.value)
                        setSelectedStateName(ele?.stateName)
                        setSelectedStateCode(ele?.stateCode)
                        setSelectedCountryName(itm[1].countryName)
                        setSelectedCountryCode(itm[1].countryCode)
                        filterData.selectFields.countrycode.value =
                          itm[1].countryCode
                        filterData.selectFields.stateprovincecode.options =
                          itm[1]?.stateWithLocations?.length > 0 && currentState
                        filterData.selectFields.stateprovincecode.value =
                          ele?.stateCode
                        filterData.selectFields.locationid.value = e?.value
                        filterData.selectFields.locationid.options =
                          countrySelected
                            ? ele?.locations
                            : [
                                {
                                  label: "Select location",
                                  value: "",
                                },
                                {
                                  label: e?.label,
                                  value: e?.value,
                                },
                              ]
                      }
                    })
                  })
                  if (!hasMatch) {
                    itm[1]?.locations?.map(obj => {
                      if (obj?.value == key[1]) {
                        const currentState = [labels?.stateSelectObj]
                        locs.push(obj.value)
                        setSelectedCountryName(itm[1].countryName)
                        setSelectedCountryCode(itm[1].countryCode)
                        filterData.selectFields.countrycode.value =
                          itm[1].countryCode
                        filterData.selectFields.stateprovincecode.options =
                          currentState
                        filterData.selectFields.locationid.value = obj?.value
                        filterData.selectFields.locationid.options =
                          countrySelected
                            ? itm[1]?.locations
                            : [
                                {
                                  label: "Select location",
                                  value: "",
                                },
                                {
                                  label: obj?.label,
                                  value: obj?.value,
                                },
                              ]
                      }
                    })
                  }
                  return ""
                })
              selectedFilters.selectedLocations = locs
            }
            if (!nonFilters.includes(key[0])) {
              selectedFilters[key[0]] = key[1]
            }
            if (key[0] == "page") {
              pageNumber = parseInt(key[1])
              algoliaPage = pageNumber - 1
              setCurrentPage(pageNumber)
            }
            selectedFilters.jobFamily =
              key[0] == "jobFamily" ? key[1] : selectedFilters.jobFamily
            selectedFilters.timeType =
              key[0] == "timeType" ? key[1] : selectedFilters.timeType
            selectedFilters.jobType =
              key[0] == "jobType" ? key[1] : selectedFilters.jobType
            if (
              key[0] != labels?.term &&
              key[0] !== labels?.checkboxLabel &&
              key[0] != "page" &&
              filterData.selectFields &&
              filterData.selectFields[key[0]]
            ) {
              filterData.selectFields[key[0]].value = key[1]
            }
            if (key[0] == labels?.checkboxLabel) {
              selectedFilters.earlyCareers = key[1]
              filterData.checkboxFields[key[0]].checked = key[1]
            }
            return ""
          })
      )

    // Commented to eliminate the duplicate api call on initial rendering
    // if (isInitialRender) {
    //   setData(() => ({
    //     ...filterData,
    //   }))
    //   setIsInitialRender(false)
    // }
    dispatch(
      getAllJobs({
        ...jobListReducer,
        filtersArr: selectedFilters,
        pageNo: algoliaPage,
        search: term?.replace(/\//g, ""),
      })
    )
    if (jobRes) {
      setIsLoading(false)
    }
  }, [data, searchTerm, currentPage, countriesListApi])

  useEffect(() => {
    setTimeout(() => {
      if (typeof window !== "undefined" && window.Cookies) {
        let params = getUTMParams(window?.location?.search)
        if (params) {
          window.Cookies.set("utmParams", params)
          setUtmParams(params)
        } else if (window.Cookies?.get("utmParams")) {
          params = window.Cookies?.get("utmParams")
          setUtmParams(params)
        }
        if (
          typeof document !== "undefined" &&
          !window.Cookies.get("sourceSiteURL")
        ) {
          const sourceSiteURL = document.referrer
            ? document.referrer
            : "Company_Website"
          window.Cookies.set("sourceSiteURL", sourceSiteURL)
        }
      }
    }, 500)
  }, [])

  const onPageChange = pageNumber => {
    setCurrentPage(pageNumber)
    updatePageUrl({ filtersData: data, search: searchTerm, pageNo: pageNumber })
  }

  const handleChange = (event, id) => {
    const tempData = data
    let currentVal =
      id == labels?.checkboxLabel
        ? event?.target?.checked
        : event?.target?.value
    id == labels?.checkboxLabel
      ? (tempData.checkboxFields[id].checked = currentVal)
      : (tempData.selectFields[id].value = currentVal)
    if (
      id == labels?.countrycode ||
      (id == labels?.stateprovincecode && currentVal == "")
    ) {
      tempData.selectFields.locationid.value = ""
      tempData.selectFields.stateprovincecode.value = ""
    }
    setData(() => ({
      ...tempData,
    }))
    setCurrentPage(1)
    updatePageUrl({ filtersData: data, search: searchTerm })
    setFilterValidation(true)
  }

  const updateFilterValidation = () => {
    setFilterValidation(false)
  }

  // to display the selected filters
  const renderSelectedFilters = () => {
    if (typeof window !== "undefined") {
      let selectedLabel = []
      const params = new URLSearchParams(window?.location?.search)
      for (const [key, value] of params) {
        params.set(key, value)
      }
      for (const [key, value] of params) {
        if (key == labels?.locationid) {
          if (params.get(labels?.countrycode) == null) {
            selectedLabel.push([selectedCountryName, labels?.countrycode])
          }
          if (params.get(labels?.stateprovincecode) == null) {
            selectedLabel.push([selectedStateName, labels?.stateprovincecode])
          }
        }
        key !== labels?.term &&
          filterData?.selectFields[key]?.options?.map(e =>
            e.value == value ? selectedLabel.push([e.label, key]) : ""
          )
      }

      function getFormattedURL(val, currentURL) {
        if (val == labels.countrycode) {
          return currentURL
        }
        if (val == labels.stateprovincecode) {
          return currentURL + `&${labels?.countrycode}=${selectedCountryCode}`
        }
        if (val == labels.locationid) {
          return (
            currentURL +
            `&${labels?.countrycode}=${selectedCountryCode}&${labels.stateprovincecode}=${selectedStateCode}`
          )
        }
      }

      return selectedLabel?.map((itm, index) => {
        let url = new URLSearchParams(window?.location?.search)
        if (itm[1] == labels?.countrycode) {
          url.delete(labels?.locationid)
          url.delete(labels?.stateprovincecode)
        }
        if (itm[1] == labels?.stateprovincecode) {
          url.delete(labels?.locationid)
        }
        url.delete(itm[1])
        let constructURL = window?.location?.pathname + "?" + url
        if (
          params.has(labels.locationid) &&
          !params.has(labels.countrycode) &&
          !params.has(labels.stateprovincecode)
        ) {
          constructURL = getFormattedURL(itm[1], constructURL)
        }
        return (
          itm[0] &&
          !itm[0].toLocaleLowerCase().includes("select") && (
            <a key={index} href={constructURL}>
              {itm[0].concat(" ").concat("x")}
            </a>
          )
        )
      })
    }
  }

  const getLoc = data => {
    let result = []
    let locName
    let countryName
    let locId
    data?.map(itm => {
      locId = itm
      countriesListApi?.map(country => {
        country?.locations?.length > 0 &&
          country?.locations?.map(location => {
            if (location?.value == itm) {
              locName = location?.label
              countryName = country?.countryName
            }
          })
      })
      result.push({
        locName: locName,
        countryName: countryName,
        locId: itm,
      })
    })
    return result
  }

  const getLocDets = data => {
    const primLoc =
      data?.Primary_Location_Reference.length > 0 &&
      getLoc(data?.Primary_Location_Reference)
    return primLoc
  }

  const formatDate = date => {
    const weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ]
    let today = new Date(date) // yyyy-mm-dd
    let day = weekday[today.getUTCDay()]
    let month = today.toLocaleString("default", { month: "long" })
    let dat = today?.getUTCDate()
    let dateFormat = dat < 10 ? "0" + today?.getUTCDate() : today?.getUTCDate()
    if (today) {
      return `${day}, ${month} ${dateFormat}, ${today?.getUTCFullYear()}`
    }
  }

  // to list all the jobs
  const renderResults = () => {
    if (hits.length > 0) {
      return hits
        ?.sort(
          (a, b) =>
            Number(new Date(b?.Job_Posting_Start_Date)) -
            Number(new Date(a?.Job_Posting_Start_Date))
        )
        ?.map((res, index) => {
          const date =
            res?.Job_Posting_Start_Date &&
            formatDate(res?.Job_Posting_Start_Date)
          const getUrl = id => {
            return `/careers/jobs?term=&locationid=${id}`
          }
          const location =
            res?.Job_Posting_Location_Data?.length > 0 &&
            getLocDets(res?.Job_Posting_Location_Data[0])
          const additionalLoc =
            res?.Job_Posting_Location_Data?.length > 0
              ? res?.Job_Posting_Location_Data[0]?.Additional_Location_Reference
                  .length > 0 &&
                getLoc(
                  res?.Job_Posting_Location_Data[0]
                    ?.Additional_Location_Reference
                )
              : ""
          const link = {
            url: `/careers/jobs/job?jobid=${
              res?.Job_Requisition_ID
            }&jobtitle=${encodeURIComponent(
              res?.Job_Posting_Title
            )}`,
          }
          if (res?.countryCode === "US") {
            if (
              labels?.Job_Profile_ID.includes(res?.Hiring_Requirement_Data[0])
            ) {
              let jobID = res?.objectID
              var paradoxlink = {
                 url: process.env.GATSBY_PARADOX_URL + jobID + `${utmParams ? `?${utmParams}` : ""}`,
              }
            }
          }
          return (
            <div key={index}>
              <p>{date}</p>
              {res?.countryCode === "US" &&
              labels?.Job_Profile_ID.includes(
                res?.Hiring_Requirement_Data[0]
              ) ? (
                <a href={paradoxlink?.url} target="_blank" rel="noreferrer">
                  {res?.Job_Posting_Title}
                </a>
              ) : (
                <a href={link?.url}>{res?.Job_Posting_Title}</a>
              )}
              <p>
                {res?.Job_Requisition_ID} |
                {location.length > 0 &&
                  location?.map((ele, index) => (
                    <a key={index} href={getUrl(ele?.locId)}>
                      {ele?.locName == undefined ? ele?.locId : ele?.locName}
                    </a>
                  ))}
                {additionalLoc.length > 0 && (
                  <span>
                    {" "}
                    | {additionalLoc?.length} other location(s) available
                  </span>
                )}
              </p>
            </div>
          )
        })
    } else if (searchTerm && hits?.length == 0) {
      return `No results found for search term ${searchTerm}.`
    } else {
      return ""
    }
  }
  const style = styles.defaultStyle
  return (
    <div className={style?.mainContainerWrapperJobList}>
      {isLoading && (
        <div className="loader">
          {" "}
          <ModalWrapper>
            <LoaderIcon />
          </ModalWrapper>
        </div>
      )}
      <BreadcrumbWrapper
        {...breadCrumbDets}
        className={style?.containerBreadcrumbWrapper}
      />
      <div className={style?.containerFormWrapper}>
        <SearchJobs
          searchTerm={searchTerm?.replace(/\//g, "")}
          setSearchTerm={setSearchTerm}
          filtersData={data}
          setCurrentPage={setCurrentPage}
          className={style?.formSearchRecipes}
          variant="SEARCH_RECIPES_JOB_LISTING"
          filterValidation={filterValidation}
          updateFilterValidation={updateFilterValidation}
        />
        <JobFilter
          {...data}
          handleChange={handleChange}
          className={style?.formJobFilter}
        />
      </div>
      <div className={style?.containerResultWrapper}>
        {appliedFilters?.prevFilters.length == 0 ||
        (appliedFilters?.prevFilters?.length > 1 &&
          Object.entries(appliedFilters?.prevFilters[1])[0][0] ==
            labels?.checkboxLabel) ||
        (appliedFilters?.prevFilters?.length == 1 &&
          Object.entries(appliedFilters?.prevFilters[0])[0][0] ==
            labels?.term) ? (
          <div className={style?.resultSearch}>
            <Link
              url={labels?.slug}
              label={labels?.newSearch}
              className={style?.resultNewSearchLink}
              gaEventClass={gaEventClick}
            />
          </div>
        ) : (
          <div className={style?.resultclearFilters}>
            <Link
              url={labels?.slug}
              label={labels?.clearFilters}
              className={style?.resultclearFiltersLink}
            />
            {renderSelectedFilters()}
          </div>
        )}
        <div className={style?.resultJobFoundRow}>
          {nbHits ? (
            <p className={style?.resultJobFoundRowPara}>{nbHits} Jobs found</p>
          ) : (
            <p className={style?.resultJobFoundRowPara}>0 Jobs found</p>
          )}
        </div>
        <div className={style?.resultFilterLine}></div>
        <div className={style?.resultRenderContainer}>{renderResults()}</div>
      </div>
      <div className={style?.containerPaginationWrapper}>
        {nbHits !== undefined && nbHits > 0 && (
          <CustomPagination
            currentPage={currentPage}
            totalCount={nbHits}
            pageSize={20}
            siblingCount={3}
            onPageChange={onPageChange}
            className={style?.customPagination}
          />
        )}
      </div>
      <ContentfulComponents componentsProps={componentProps?.slice(2)} />
    </div>
  )
}

JobListing.propTypes = {
  pageContext: PropTypes.shape({
    seoData: PropTypes.array,
    globalComponents: PropTypes.array,
    dataLayer: PropTypes.object,
  }),
}

export default JobListing